import { recoveryPage, startedRequest, TemplateField, TemplateGroup, TemplatePage, TemplateSection, Traduction } from "../../../../api/applicationService"
import { extractValue } from "./fields";
import { Dependent } from "../../utils/shared";
import { ApplicationSummary } from "../../../common/summary-common/applicationSummary";


export const FORM_INTERNATIONAL = {
    PAGE_INSURED_INFORMATION: '0d7e941e-7c31-41ee-95f4-622c54525a72',
    PAGE_OWNER_INFORMATION: 'd487348e-4062-4daa-92fc-854869a2fc81',
    PAGE_ADD_DEPENDENT: '9fbde5cb-9b88-47d2-aa6e-83c6c33ccf66',
    PAGE_CREDIT_GUARANTEE: 'e67fe061-ef65-4e06-86f6-4498b3d9ea69',
    PAGE_OCUPATION_INFORMATION: '8cfdcedb-484c-4633-bcc2-17fe2447a5c8',
    PAGE_INCOME_INFORMATION: '4ad0e8b3-a435-4990-92db-7e7e61cb954c',
    PAGE_PEP: '96f38ebf-5a72-4d76-b0db-e56b9356df0a',
    PAGE_EXTREME_SPORTS: '0ac905cb-800c-4db8-ba9e-9a7874cbeb34',
    PAGE_DEEP_1: '69e6100c-1a76-4330-b750-cb35c5472d36',
    PAGE_DEEP_2: 'bfe6c586-e763-44aa-ae04-3e3000cb5380',
    PAGE_DEEP_3: '6d533b7f-5698-4eaa-a9ce-a7c47f320a89',
    PAGE_DEEP_4: '35a04d2e-a8c0-4313-be5b-e531c219f9b1',
    PAGE_DEEP_5: 'aa074f57-9cec-48a7-a61e-4d12f0a04deb',
    PAGE_MONT_1: 'd10fc68c-1ee8-435d-a136-70916b6e8907',
    PAGE_MONT_2: '90ab8a8e-22b0-42a6-a0d2-e02db8c02f00',
    PAGE_MONT_3: '8f55eb85-6324-463f-b035-a52457a05c8c',
    PAGE_MONT_4: '89e56224-de88-466e-a3a2-11c26be51995',
    PAGE_WEIGHT_AND_HEIGHT: '98dc7e3f-19cf-4ec6-80e1-7b9b922e900e',
    PAGE_DISEASES_PART_1: '5d277b8b-6318-4f43-8b22-5bd9f69d1658',
    PAGE_DISEASES_PART_2: 'de057444-1ac0-43da-8cff-0b21d2f63ef6',
    PAGE_DISEASES_PART_3: 'ba08302f-5328-44bf-85bd-f377974da10b',
    PAGE_DISEASES_HEART_1: '2e9ec1a1-054e-4a2f-9f43-cd23f9fb272a',
    PAGE_DISEASES_HEART_2: '544a1eb6-b33b-4ba2-8854-62d85dd716de',
    PAGE_DISEASES_RESPIRATORY_1: '45fbdd22-a478-480f-9e42-fd1b0f213306',
    PAGE_DISEASES_RESPIRATORY_2: 'c3ba699c-f173-4f13-84b7-59cdd9d2e579',
    PAGE_DISEASES_RESPIRATORY_3: '2435169b-5fbe-438c-8e1c-6bea8f84d776',
    PAGE_DISEASES_RESPIRATORY_4: '99fc15df-21a9-454b-8c98-a1de719c4362',
    PAGE_DISEASES_CANCER_1: '59ba071c-9696-4e03-8c6e-de1bd3abd809',
    PAGE_DISEASES_DIABETES_1: 'c117f0fe-c687-4cf1-9428-8a672d36b434',
    PAGE_DISEASES_DIABETES_2: '48eb7343-efb5-447f-9883-7aa0661e5c83',
    PAGE_DISEASES_DIGESTIVE_1: '449763f5-7a20-4eed-a9c0-1679d19f1005',
    PAGE_DISEASES_URINAL_1: 'f0b7cc30-6245-4293-96f0-2fe0bff87440',
    PAGE_DISEASES_NEURO_1: 'f75336d7-cd43-4a1c-95d3-136adb13f2c8',
    PAGE_DISEASES_NEURO_2: 'c4b3268a-5fba-41fe-91e2-b38cd184f299',
    PAGE_DISEASES_NEURO_3: '2258d150-3cd5-4300-858e-decc15f48e1b',
    PAGE_DISEASES_NEURO_4: '0bb664c3-720a-49ea-aa07-3d307357a930',
    PAGE_DISEASES_NEURO_5: '4a2866c6-d1d6-4d90-9dc8-728c640e3ba6',
    PAGE_DISEASES_ANEMIA_1: '33a0e6e5-c529-4cc7-ac12-20e3b480b93a',
    PAGE_DISEASES_MENTAL_1: 'ce92985c-c827-4437-b4c6-8fbb130ddbcd',
    PAGE_DISEASES_MENTAL_2: 'bfdabbae-399a-47d5-9f4d-f22a34c6c719',
    PAGE_DISEASES_MENTAL_3: '1271b2a1-8f78-482f-8824-e8481a71cf56',
    PAGE_DISEASES_MENTAL_4: '5a4c32e0-c4a8-4111-879d-5e97e788305b',
    PAGE_DISEASES_MUSCLE_1: 'ca971a79-7736-4ef5-8903-f92ddcc6b210',
    PAGE_DISEASES_MUSCLE_2:  'a1b5f826-0921-4cff-9511-5574313b68a3',
    PAGE_DISEASES_MUSCLE_3: '4df604ae-4da5-403d-889f-5ddf56443e66',
    PAGE_DISEASES_INMUNE_SYSTEM_1: '133b3a35-1c82-4b66-aa24-956f01062da4',
    PAGE_DISEASES_MEDICAL_CONDITION_1: '6105330c-5aae-4a7b-b597-aa84f7e573b5',
    PAGE_ADDITIONAL_MEDICAL_QUESTIONS: '6819c081-02fa-4763-9ce5-65d14ca50b9e',
    PAGE_INSURANCE_QUESTIONS: '5bb55af3-e811-407c-87c1-711758b6066a',
    PAGE_DRUGS: '1e13cae4-72e6-4450-9380-68aa61c1dada',
    PAGE_RESIDENCE_TRAVEL_PART_1: '77d2bace-ee51-497e-af55-6543e20d2ae2',
    PAGE_RESIDENCE_TRAVEL_PART_2: 'c96e1328-d2be-4b25-acda-a2c4be88ab7a',
    PAGE_FINANCIAL_QUESTIONNAIRE_PART_1: 'fc943429-3caf-4962-b6df-f46bb8058524',
    PAGE_FINANCIAL_QUESTIONNAIRE_PART_2: '4ba68098-7678-470e-b299-b0fcd1e0ec83',
    PAGE_BENEFICIARIES: 'f4f489ee-3e2a-4eb2-9542-0f1da59a2d20',
    PAGE_RELATION: '259bcc99-1dd0-45c0-a143-9b65cf9eb7f8',
}

export const DICTIONARY_DISEASES = [
    FORM_INTERNATIONAL.PAGE_DISEASES_HEART_1,
    FORM_INTERNATIONAL.PAGE_DISEASES_HEART_2,
    FORM_INTERNATIONAL.PAGE_DISEASES_RESPIRATORY_1,
    FORM_INTERNATIONAL.PAGE_DISEASES_RESPIRATORY_2,
    FORM_INTERNATIONAL.PAGE_DISEASES_RESPIRATORY_3,
    FORM_INTERNATIONAL.PAGE_DISEASES_RESPIRATORY_4,
    FORM_INTERNATIONAL.PAGE_DISEASES_CANCER_1,
    FORM_INTERNATIONAL.PAGE_DISEASES_DIABETES_1,
    FORM_INTERNATIONAL.PAGE_DISEASES_DIABETES_2,
    FORM_INTERNATIONAL.PAGE_DISEASES_DIGESTIVE_1,
    FORM_INTERNATIONAL.PAGE_DISEASES_URINAL_1,
    FORM_INTERNATIONAL.PAGE_DISEASES_NEURO_1,
    FORM_INTERNATIONAL.PAGE_DISEASES_NEURO_2,
    FORM_INTERNATIONAL.PAGE_DISEASES_NEURO_3,
    FORM_INTERNATIONAL.PAGE_DISEASES_NEURO_4,
    FORM_INTERNATIONAL.PAGE_DISEASES_NEURO_5,
    FORM_INTERNATIONAL.PAGE_DISEASES_ANEMIA_1,
    FORM_INTERNATIONAL.PAGE_DISEASES_MENTAL_1,
    FORM_INTERNATIONAL.PAGE_DISEASES_MENTAL_2,
    FORM_INTERNATIONAL.PAGE_DISEASES_MENTAL_3,
    FORM_INTERNATIONAL.PAGE_DISEASES_MENTAL_4,
    FORM_INTERNATIONAL.PAGE_DISEASES_MUSCLE_1,
    FORM_INTERNATIONAL.PAGE_DISEASES_MUSCLE_2,
    FORM_INTERNATIONAL.PAGE_DISEASES_MUSCLE_3,
    FORM_INTERNATIONAL.PAGE_DISEASES_INMUNE_SYSTEM_1,
    FORM_INTERNATIONAL.PAGE_DISEASES_MEDICAL_CONDITION_1
]

export const DICTIONARY = [
  { page: '0d7e941e-7c31-41ee-95f4-622c54525a72', before: '', after: 'e67fe061-ef65-4e06-86f6-4498b3d9ea69' },
  { page: 'e67fe061-ef65-4e06-86f6-4498b3d9ea69', before: '0d7e941e-7c31-41ee-95f4-622c54525a72', after: '8cfdcedb-484c-4633-bcc2-17fe2447a5c8' },
  { page: '8cfdcedb-484c-4633-bcc2-17fe2447a5c8', before: 'e67fe061-ef65-4e06-86f6-4498b3d9ea69', after: '4ad0e8b3-a435-4990-92db-7e7e61cb954c' },
  { page: '4ad0e8b3-a435-4990-92db-7e7e61cb954c', before: '8cfdcedb-484c-4633-bcc2-17fe2447a5c8', after: '96f38ebf-5a72-4d76-b0db-e56b9356df0a' },
  { page: '96f38ebf-5a72-4d76-b0db-e56b9356df0a', before: '4ad0e8b3-a435-4990-92db-7e7e61cb954c', after: '0ac905cb-800c-4db8-ba9e-9a7874cbeb34' },
  { page: '0ac905cb-800c-4db8-ba9e-9a7874cbeb34', before: '96f38ebf-5a72-4d76-b0db-e56b9356df0a', after: '98dc7e3f-19cf-4ec6-80e1-7b9b922e900e' },
  { page: '98dc7e3f-19cf-4ec6-80e1-7b9b922e900e', before: '0ac905cb-800c-4db8-ba9e-9a7874cbeb34', after: '5d277b8b-6318-4f43-8b22-5bd9f69d1658' },
  { page: '5d277b8b-6318-4f43-8b22-5bd9f69d1658', before: '98dc7e3f-19cf-4ec6-80e1-7b9b922e900e', after: 'de057444-1ac0-43da-8cff-0b21d2f63ef6' },
  { page: 'de057444-1ac0-43da-8cff-0b21d2f63ef6', before: '5d277b8b-6318-4f43-8b22-5bd9f69d1658', after: 'ba08302f-5328-44bf-85bd-f377974da10b' },
  { page: 'ba08302f-5328-44bf-85bd-f377974da10b', before: 'de057444-1ac0-43da-8cff-0b21d2f63ef6', after: '6819c081-02fa-4763-9ce5-65d14ca50b9e' },
  { page: '6819c081-02fa-4763-9ce5-65d14ca50b9e', before: 'ba08302f-5328-44bf-85bd-f377974da10b', after: '5bb55af3-e811-407c-87c1-711758b6066a' },
  { page: '5bb55af3-e811-407c-87c1-711758b6066a', before: '6819c081-02fa-4763-9ce5-65d14ca50b9e', after: '1e13cae4-72e6-4450-9380-68aa61c1dada' },
  { page: '1e13cae4-72e6-4450-9380-68aa61c1dada', before: '5bb55af3-e811-407c-87c1-711758b6066a', after: 'fc943429-3caf-4962-b6df-f46bb8058524' },
  { page: 'fc943429-3caf-4962-b6df-f46bb8058524', before: '1e13cae4-72e6-4450-9380-68aa61c1dada', after: '4ba68098-7678-470e-b299-b0fcd1e0ec83' },
  { page: '4ba68098-7678-470e-b299-b0fcd1e0ec83', before: 'fc943429-3caf-4962-b6df-f46bb8058524', after: 'f4f489ee-3e2a-4eb2-9542-0f1da59a2d20' },
  { page: 'f4f489ee-3e2a-4eb2-9542-0f1da59a2d20', before: '4ba68098-7678-470e-b299-b0fcd1e0ec83', after: '259bcc99-1dd0-45c0-a143-9b65cf9eb7f8' },
];

export  interface UserDiseases {
    block: string;
    diseases: string[];
}

export const getInsuredInformation = async(product: string, quoteID: string, language: string) => {
    console.log('[getInsuredInformation] start');
    const getInfoRequest = await startedRequest(product, quoteID, language, 'int');
    console.log('[getInsuredInformation] getInfoRequest', getInfoRequest);
    const pages = getInfoRequest?.pages || [];
    const pageInfo = pages?.find((page: any) => page.template_page_id === FORM_INTERNATIONAL.PAGE_INSURED_INFORMATION);
    console.log('[getInsuredInformation] pageInfo', pageInfo);
    const tmp = await recoveryPage(pageInfo?.id || 0);
    const pageInsured = tmp?.json;
    console.log('[getInsuredInformation] pageInsured', pageInsured);

    const insured:Dependent = {
        id: '',
        name: '',
        relationship: language === 'es' ? 'Asegurado principal' : 'Main Insured',
    }
    const group = pageInsured?.sections?.find((section: TemplateSection) => section.section_id === '872a5c66-cd6e-4fbc-baa8-0b5ff69f446c')?.groups?.find((group: TemplateGroup) => group.group_id === '3e75c9bf-b2aa-4e43-896a-b3ed637de929');
    console.log('[getInsuredInformation] group', group);
    let fieldIdentify = '';
    let fieldPassport = '';

    group?.fields?.forEach((field: TemplateField) => {
        if (field?.question_id === '0020fdeb-7776-4959-9ff2-198c2469eb27') {
            fieldIdentify = field?.value || '';
        }
        if (field?.question_id === '9e8e4349-5f9a-43e7-a048-856955040966') {
            fieldPassport = field?.value || '';
        }
        if (field?.question_id === '773e8c82-3c69-4745-8520-43ac32b1b030') {
            insured.name = field?.value || '';
        }
        if (field?.question_id === '84f4b5e2-a240-4405-839b-a35924df2fa8') {
            insured.name = insured.name.concat(' ').concat(field?.value || '');
        }
    });
    const document = fieldIdentify || fieldPassport;
    insured.id = document;

    return insured;
}

export const getDependents = async(page:TemplatePage| ApplicationSummary | null, product: string, quoteID: string, language: string = 'es') => {
    console.log('[getDependents] with dependents');
    let getStructPageDependent = page;
    if (!page) {
        const getInfoRequest = await startedRequest(product, quoteID, language, 'int');
        console.log('[getDependents] getInfoRequest', getInfoRequest);
        const pages = getInfoRequest?.pages || [];
        const pageInfoDependent = pages?.find((page: any) => page.template_page_id === '9fbde5cb-9b88-47d2-aa6e-83c6c33ccf66');
        console.log('[getDependents] pageInfoDependent', pageInfoDependent);
        const tmp = await recoveryPage(pageInfoDependent?.id || 0);
        getStructPageDependent = tmp?.json;
        console.log('[getDependents] getStructPageDependent', getStructPageDependent);
    }
    const dependents:Dependent[] = []
    const mainInsured = await getInsuredInformation(product, quoteID, language);
    dependents.push(mainInsured);
    const section = getStructPageDependent ? (('sections' in getStructPageDependent) 
        ? getStructPageDependent.sections?.find((section: TemplateSection) => section.section_id === '9f75f289-6a25-4fff-94d5-99765c78ba6c')
        : getStructPageDependent.json?.sections?.find((section: TemplateSection) => section.section_id === '9f75f289-6a25-4fff-94d5-99765c78ba6c')) : undefined;
    console.log('[getDependents] section found:', section);
    const groupWithDependents = section?.groups?.filter((group: TemplateGroup) => group.group_id !== 'c30e62e6-838d-48bd-968c-1760519e3535' && group.group_id !== 'd736ecdc-6ee5-44e1-a035-91c4fb7a8d7c') ?? [];
    console.log('[getDependents] groupWithDependents', groupWithDependents);
    groupWithDependents?.forEach((group: TemplateGroup) => {
        let fieldName = '';
        let fieldRelation = '';
        let fieldIdentify = '';
        let fieldPassport = '';
        group?.fields?.forEach((field: TemplateField) => {
            if (field?.question_id === '0020fdeb-7776-4959-9ff2-198c2469eb27') {
                fieldIdentify = field?.value || '';
            }
            if (field?.question_id === '9e8e4349-5f9a-43e7-a048-856955040966') {
                fieldPassport = field?.value || '';
            }
            if (field?.question_id === '773e8c82-3c69-4745-8520-43ac32b1b030') {
                fieldName = field?.value || '';
            }
            if (field?.question_id === '84f4b5e2-a240-4405-839b-a35924df2fa8') {
                fieldName = fieldName.concat(' ').concat(field?.value || '');
            }
            if (field?.question_id === '0a010b29-7593-4406-a2bb-e5ac91a7b035') {
                const relation = field?.options?.find((option: any) => option.key === field?.value)?.value as Traduction;
                fieldRelation = relation[language] || '';
            }
        });
        const document = fieldIdentify || fieldPassport;
        dependents.push({
            id: document,
            name: fieldName,
            relationship: fieldRelation,
        });
    });
    console.log('[getDependents] dependents', dependents);
    return dependents;
}

export const recoverSelectedDiseases = async (idPage1: number, idPage2: number, page3: TemplatePage, hasDependent:boolean) => {
    console.log('[recoverSelectedDiseases] idPage1', idPage1);
    console.log('[recoverSelectedDiseases] idPage2', idPage2);
    console.log('[recoverSelectedDiseases] page3', page3);
    const page1 = await recoveryPage(idPage1);
    const page2 = await recoveryPage(idPage2);
    const selectedDiseases: any[] = [];
    if (!hasDependent) {
        console.log('[recoverSelectedDiseases] page without dependents');
        const value1 = extractValue(page1?.json, 'f6fb3378-eb02-4603-a3e7-153045ccaef6', '3ebc50c5-946c-43b2-82b3-c79f1c40ea19', 'ad1e32bd-6976-4068-80c1-6ccbd441e1ed');
        console.log('[recoverSelectedDiseases] page 1 values:', value1);
        if (value1.includes('1')) {
            selectedDiseases.push(FORM_INTERNATIONAL.PAGE_DISEASES_HEART_1, FORM_INTERNATIONAL.PAGE_DISEASES_HEART_2);
        }
        if (value1.includes('2')) {
            selectedDiseases.push(FORM_INTERNATIONAL.PAGE_DISEASES_RESPIRATORY_1, FORM_INTERNATIONAL.PAGE_DISEASES_RESPIRATORY_2, FORM_INTERNATIONAL.PAGE_DISEASES_RESPIRATORY_3, FORM_INTERNATIONAL.PAGE_DISEASES_RESPIRATORY_4);
        }
        if (value1.includes('3')) {
            selectedDiseases.push(FORM_INTERNATIONAL.PAGE_DISEASES_CANCER_1);
        }
        if (value1.includes('4')) {
            selectedDiseases.push(FORM_INTERNATIONAL.PAGE_DISEASES_DIABETES_1, FORM_INTERNATIONAL.PAGE_DISEASES_DIABETES_2);
        }
        console.log('[recoverSelectedDiseases] page 1 selectedDiseases:', selectedDiseases);
        const value2 = extractValue(page2?.json, 'fef69e66-cb79-485b-a822-8353ea703233', '93db15e9-7bf3-4feb-816b-6f6539f56c4d', 'd97c485f-51db-40fe-8304-6cc457a095a4');
        console.log('[recoverSelectedDiseases] page 2 values:', value2);
        if (value2.includes('1')) {
            selectedDiseases.push(FORM_INTERNATIONAL.PAGE_DISEASES_DIGESTIVE_1);
        }
        if (value2.includes('2')) {
            selectedDiseases.push(FORM_INTERNATIONAL.PAGE_DISEASES_URINAL_1);
        }
        if (value2.includes('3')) {
            selectedDiseases.push(FORM_INTERNATIONAL.PAGE_DISEASES_NEURO_1, FORM_INTERNATIONAL.PAGE_DISEASES_NEURO_2, FORM_INTERNATIONAL.PAGE_DISEASES_NEURO_3, FORM_INTERNATIONAL.PAGE_DISEASES_NEURO_4, FORM_INTERNATIONAL.PAGE_DISEASES_NEURO_5);
        }
        if (value2.includes('4')) {
            selectedDiseases.push(FORM_INTERNATIONAL.PAGE_DISEASES_ANEMIA_1);
        }
        console.log('[recoverSelectedDiseases] page 2 selectedDiseases:', selectedDiseases);
        const valuesPage3 = extractValue(page3, 'a37e533c-9b2e-486b-8f6f-53f82d4029a6', '5b0edc18-bdf3-440e-b35c-c4a14dcf2c6e', '4ea018bf-7570-4e4c-adc5-617077134715');
        console.log('[recoverSelectedDiseases] page 3 values:', valuesPage3);
        if (valuesPage3.includes('1')) {
            selectedDiseases.push(FORM_INTERNATIONAL.PAGE_DISEASES_MENTAL_1, FORM_INTERNATIONAL.PAGE_DISEASES_MENTAL_2, FORM_INTERNATIONAL.PAGE_DISEASES_MENTAL_3, FORM_INTERNATIONAL.PAGE_DISEASES_MENTAL_4);
        }
        if (valuesPage3.includes('2')) {
            selectedDiseases.push(FORM_INTERNATIONAL.PAGE_DISEASES_MUSCLE_1, FORM_INTERNATIONAL.PAGE_DISEASES_MUSCLE_2, FORM_INTERNATIONAL.PAGE_DISEASES_MUSCLE_3);
        }
        if (valuesPage3.includes('3')) {
            selectedDiseases.push(FORM_INTERNATIONAL.PAGE_DISEASES_INMUNE_SYSTEM_1);
        }
        if (valuesPage3.includes('4')) {
            selectedDiseases.push(FORM_INTERNATIONAL.PAGE_DISEASES_MEDICAL_CONDITION_1);
        }
        console.log('[recoverSelectedDiseases] total selectedDiseases:', selectedDiseases);
        return [{
            block: 'insured',
            diseases: selectedDiseases,
        }]
    } else {
        const arrayDiseases: UserDiseases[] = [];
        //page 1
        const d_heart_values = extractValue(page1?.json, '3a1c25fa-0c6f-486e-a03f-725d9266f830', 'cdafc4ed-7bf2-479f-955d-57e0fb047fc0', '9cbfbf47-5add-4a24-94ab-b57065e96f0e');
        const d_respiratory_values = extractValue(page1?.json, '3a1c25fa-0c6f-486e-a03f-725d9266f830', '81ad9fdd-c7b6-46c8-88a9-999c0c94ace5', '9cbfbf47-5add-4a24-94ab-b57065e96f0e');
        const d_cancer_values = extractValue(page1?.json, '3a1c25fa-0c6f-486e-a03f-725d9266f830', 'acfb1559-0f04-440d-8816-616d1b100230', '9cbfbf47-5add-4a24-94ab-b57065e96f0e');
        const d_diabetes_values = extractValue(page1?.json, '3a1c25fa-0c6f-486e-a03f-725d9266f830', 'feed2721-5efb-4c21-aeb8-f3e7880716f9', '9cbfbf47-5add-4a24-94ab-b57065e96f0e');
        const d_heart = d_heart_values.split(',').filter((item: string) => item !== '');
        const d_respiratory = d_respiratory_values.split(',').filter((item: string) => item !== '');
        const d_cancer = d_cancer_values.split(',').filter((item: string) => item !== '');
        const d_diabetes = d_diabetes_values.split(',').filter((item: string) => item !== '');
        //llenar la interfaz UserDiseases con los valores del array
        d_heart.forEach((document: string) => {
            arrayDiseases.push({
                block: document,
                diseases: [FORM_INTERNATIONAL.PAGE_DISEASES_HEART_1, FORM_INTERNATIONAL.PAGE_DISEASES_HEART_2]
            });
        });
        d_respiratory.forEach((document: string) => {
            arrayDiseases.push({
                block: document,
                diseases: [FORM_INTERNATIONAL.PAGE_DISEASES_RESPIRATORY_1, FORM_INTERNATIONAL.PAGE_DISEASES_RESPIRATORY_2, FORM_INTERNATIONAL.PAGE_DISEASES_RESPIRATORY_3, FORM_INTERNATIONAL.PAGE_DISEASES_RESPIRATORY_4]
            });
        });
        d_cancer.forEach((document: string) => {
            arrayDiseases.push({
                block: document,
                diseases: [FORM_INTERNATIONAL.PAGE_DISEASES_CANCER_1]
            });
        }
        );
        d_diabetes.forEach((document: string) => {
            arrayDiseases.push({
                block: document,
                diseases: [FORM_INTERNATIONAL.PAGE_DISEASES_DIABETES_1, FORM_INTERNATIONAL.PAGE_DISEASES_DIABETES_2]
            });
        }
        );
        //page 2
        const d_digestive_values = extractValue(page2?.json, 'd440f599-b1cd-4b8a-8d7f-7944c86617c8', '6c5768d4-4919-49b0-8499-88b9396795d3', '9cbfbf47-5add-4a24-94ab-b57065e96f0e');
        const d_urinal_values = extractValue(page2?.json, 'd440f599-b1cd-4b8a-8d7f-7944c86617c8', '575b6582-f00f-4252-903a-b48c6ec2640d', '9cbfbf47-5add-4a24-94ab-b57065e96f0e');
        const d_neuro_values = extractValue(page2?.json, 'd440f599-b1cd-4b8a-8d7f-7944c86617c8', '4153e83a-7074-4a4c-a844-c5516a0375b1', '9cbfbf47-5add-4a24-94ab-b57065e96f0e');
        const d_anemia_values = extractValue(page2?.json, 'd440f599-b1cd-4b8a-8d7f-7944c86617c8', '5210c536-09a4-4105-9678-43b0dfce1704', '9cbfbf47-5add-4a24-94ab-b57065e96f0e');
        const d_digestive = d_digestive_values.split(',').filter((item: string) => item !== '');
        const d_urinal = d_urinal_values.split(',').filter((item: string) => item !== '');
        const d_neuro = d_neuro_values.split(',').filter((item: string) => item !== '');
        const d_anemia = d_anemia_values.split(',').filter((item: string) => item !== '');
        //llenar la interfaz UserDiseases con los valores del array
        d_digestive.forEach((document: string) => {
            arrayDiseases.push({
                block: document,
                diseases: [FORM_INTERNATIONAL.PAGE_DISEASES_DIGESTIVE_1]
            });
        });
        d_urinal.forEach((document: string) => {
            arrayDiseases.push({
                block: document,
                diseases: [FORM_INTERNATIONAL.PAGE_DISEASES_URINAL_1]
            });
        }
        );
        d_neuro.forEach((document: string) => {
            arrayDiseases.push({
                block: document,
                diseases: [FORM_INTERNATIONAL.PAGE_DISEASES_NEURO_1, FORM_INTERNATIONAL.PAGE_DISEASES_NEURO_2, FORM_INTERNATIONAL.PAGE_DISEASES_NEURO_3, FORM_INTERNATIONAL.PAGE_DISEASES_NEURO_4, FORM_INTERNATIONAL.PAGE_DISEASES_NEURO_5]
            });
        }
        );
        d_anemia.forEach((document: string) => {
            arrayDiseases.push({
                block: document,
                diseases: [FORM_INTERNATIONAL.PAGE_DISEASES_ANEMIA_1]
            });
        }
        );
        //page 3
        const d_mental_values = extractValue(page3?.json, '5c01e574-f3cc-4bb0-93fd-00bb6f5a0c33', '0fd009a8-02d8-41c6-99a1-8e99848eb592', '9cbfbf47-5add-4a24-94ab-b57065e96f0e');
        const d_muscle_values = extractValue(page3?.json, '5c01e574-f3cc-4bb0-93fd-00bb6f5a0c33', '9f20403e-60ec-40a7-971c-3a52080d3212', '9cbfbf47-5add-4a24-94ab-b57065e96f0e');
        const d_inmune_values = extractValue(page3?.json, '5c01e574-f3cc-4bb0-93fd-00bb6f5a0c33', 'debab149-b33e-424e-99ce-ec043d93b94a', '9cbfbf47-5add-4a24-94ab-b57065e96f0e');
        const d_medical_values = extractValue(page3?.json, '5c01e574-f3cc-4bb0-93fd-00bb6f5a0c33', 'e35bd793-0586-4479-86a0-054ab07f7bd8', '9cbfbf47-5add-4a24-94ab-b57065e96f0e');
        //Evitar valores vacios en los array
        const d_mental = d_mental_values.split(',').filter((item: string) => item !== '');
        const d_muscle = d_muscle_values.split(',').filter((item: string) => item !== '');
        const d_inmune = d_inmune_values.split(',').filter((item: string) => item !== '');
        const d_medical = d_medical_values.split(',').filter((item: string) => item !== '');
        //llenar la interfaz UserDiseases con los valores del array
        d_mental.forEach((document: string) => {
            arrayDiseases.push({
                block: document,
                diseases: [FORM_INTERNATIONAL.PAGE_DISEASES_MENTAL_1, FORM_INTERNATIONAL.PAGE_DISEASES_MENTAL_2, FORM_INTERNATIONAL.PAGE_DISEASES_MENTAL_3, FORM_INTERNATIONAL.PAGE_DISEASES_MENTAL_4]
            });
        });
        d_muscle.forEach((document: string) => {
            arrayDiseases.push({
                block: document,
                diseases: [FORM_INTERNATIONAL.PAGE_DISEASES_MUSCLE_1, FORM_INTERNATIONAL.PAGE_DISEASES_MUSCLE_2, FORM_INTERNATIONAL.PAGE_DISEASES_MUSCLE_3]
            });
        }
        );
        d_inmune.forEach((document: string) => {
            arrayDiseases.push({
                block: document,
                diseases: [FORM_INTERNATIONAL.PAGE_DISEASES_INMUNE_SYSTEM_1]
            });
        }
        );
        d_medical.forEach((document: string) => {
            arrayDiseases.push({
                block: document,
                diseases: [FORM_INTERNATIONAL.PAGE_DISEASES_MEDICAL_CONDITION_1]
            });
        }
        );
       //obtener los block únicos
        const uniqueBlocks = arrayDiseases.reduce((acc: any, current: UserDiseases) => {
            const x = acc.find((item: UserDiseases) => item.block === current.block);
            if (!x) {
                return acc.concat([current]);
            } else {
                return acc;
            }
        }, []);
        console.log('[recoverSelectedDiseases] uniqueBlocks', uniqueBlocks);
        const group:UserDiseases[] = [];
        uniqueBlocks.forEach((block: UserDiseases) => {
            const diseases: string[] = [];
            arrayDiseases.forEach((item: UserDiseases) => {
                if (block.block === item.block) {
                    diseases.push(...item.diseases);
                }
            });
            group.push({ block: block.block, diseases: diseases });
        }
        );
        console.log('[recoverSelectedDiseases] group', group);
        return group; 
    }

}